module.exports = __webpack_public_path__ + "img/user16.f56d3d95.jpg";